<template lang="pug">
BaseButton.BaseButtonAddEvent(
  tag="a"
  :href="href",
  target="_blank",
  rel="noopener nofollow",
  v-bind="$attrs"
)
  slot
</template>

<script>
import CONFIG from 'Config';
import { getUrlParamsByObject } from 'Utils/url';
import BaseButton from 'Components/Base/BaseButton';

const defaultParams = {
  client: CONFIG.addEventClientId,
};

export default {
  name: 'BaseButtonAddEvent',
  components: { BaseButton },
  props: {
    params: {
      type: Object,
      default: () => {},
      required: true,
    },
    service: {
      type: String,
      default: 'google',
    },
  },
  computed: {
    normalizedParams() {
      // Merge all params
      const params = {
        ...defaultParams,
        service: this.service,
        ...this.params,
      };
      // Convert object date to accepted string
      if (params.start instanceof Date) params.start = params.start.toISOString();
      if (params.end instanceof Date) params.end = params.end.toISOString();
      return params;
    },
    urlParams() {
      return getUrlParamsByObject(this.normalizedParams);
    },
    href() {
      return `https://www.addevent.com/dir/${this.urlParams}`;
    },
  },
};
</script>

<style lang="sass" scoped>
.base-btn
  height: auto !important
  min-width: auto !important
  padding: 0 !important
  box-shadow: none !important
  background: transparent !important
</style>
